import React, { useState, useEffect } from "react";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import axios from "axios";
import MarkerClusterGroup from "react-leaflet-markercluster";
import Navbar from "./Navbar_public";

import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  Tooltip,
  WMSTileLayer,
} from "react-leaflet";
import { Icon, popup } from "leaflet";
import "../component/Mapsnewcss.css";
import moment from "moment";
import pm25 from "../image/PM-2.5.png";
import pm10 from "../image/PM-10.png";
import aqi from "../image/AQI-Legend.png";
import fileDownload from "js-file-download";
import "bootstrap/dist/css/bootstrap.css";

var good_icon = new Icon({
  iconUrl: "http://nbiot.urbansciences.in/image-marker/good.png",
  iconSize: [35, 35],
  iconAnchor: [17, 34],
});

var satisfactory_icon = new Icon({
  iconUrl: "http://nbiot.urbansciences.in/image-marker/Satisfactory.png",
  iconSize: [35, 35],
  iconAnchor: [17, 34],
});

var moderate_icon = new Icon({
  iconUrl: "http://nbiot.urbansciences.in/image-marker/moderate.png",
  iconSize: [35, 35],
  iconAnchor: [17, 34],
});

var poor_icon = new Icon({
  iconUrl: "http://nbiot.urbansciences.in/image-marker/poor.png",
  iconSize: [35, 35],
  iconAnchor: [17, 34],
});

var verypoor_icon = new Icon({
  iconUrl: "http://nbiot.urbansciences.in/image-marker/very-poor.png",
  iconSize: [35, 35],
  iconAnchor: [17, 34],
});

var severe_icon = new Icon({
  iconUrl: "http://nbiot.urbansciences.in/image-marker/severe.png",
  iconSize: [35, 35],
  iconAnchor: [17, 34],
});

function Mapsnew() {
  /****************************STATE******************************/

  var [tiptoolpara, setTiptoolpara] = useState("pm_2.5_raw_mean");
  /* tiptoolpara states = [pm_2.5_raw_mean, pm_10_raw_mean, aqi]
    Allows us to toggle the map tooltip markers to show one of these 3 properties 
  */
  var [filterall, setFilterAll] = useState("1");
  const [content, setContent] = useState("status");
  const [mapcoor, setMapcoor] = useState([]);
  const [alldata, setAlldata] = useState("mapdatapoint1");
  const [markercd, setMarkercd] = useState("cluster");

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  //////////////////////////////STYLE///////////////////////////////////
  const inputStyle = {
    width: "125px",
  };
  const inputLable = {
    marginBottom: "0px",
    color: "#A4A4A4",
    fontFamily: "Roboto",
    fontSize: "15px",
    lineHeight: "18px",
    fontWeight: "normal",
  };

  ///////////////////////////////HANDLE FUNCTION/////////////////////////

  const handleFilterImei = (event) => {
    setFilterAll(event.target.value);
    setContent("imei");
    setAlldata("mapdatapoint1");
  };

  const handleFilterLocality = (event) => {
    setFilterAll(event.target.value);
    setContent("locality");
    setAlldata("mapdatapoint1");
  };
  const handleAlldata = (event) => {
    setAlldata(event.target.value);
  };

  let mapdatapoint1;
  let legend;
  let cluster;

  /////////////////////////////URL MOUNT/////////////////////////////////////

  useEffect(() => {
    fetch("https://atmos.urbansciences.in/adp/v4/getMapImei/username/atmos_share")
      .then((res) => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setMapcoor((result = result.features));
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  }, []);

  const handleAqi = () => {
    setTiptoolpara("aqi");
  };

  const handlePm25 = () => {
    setTiptoolpara("pm_2.5_raw_mean");
  };

  const handlePm10 = () => {
    setTiptoolpara("pm_10_raw_mean");
  };

  const handleReset = () => {
    setFilterAll("1");
    setContent("status");
    setAlldata("mapdatapoint1");
  };
  const locationOption = mapcoor
    .filter((obj) => obj.properties.locality != null)
    .map((obj) => obj.properties.locality);
  const newLocation = locationOption.filter(
    (item, index) => locationOption.indexOf(item) == index
  );

  function handleCssForLegend(code) {
    // returns AQI class or category for 3 ranges (aqi, pm25, pm10)

    if (tiptoolpara === "pm_2.5_raw_mean") {
      switch (true) {
        case code >= 0 && code <= 30:
          return "good";
        case code >= 31 && code <= 60:
          return "satisfactory";
        case code >= 61 && code <= 90:
          return "moderate";
        case code >= 91 && code <= 120:
          return "poor";
        case code >= 121 && code <= 250:
          return "verypoor";
        case code >= 251 && code <= 2000: // 2000 is abitrary boundary for sanity check  
          return "severe";
        default:
          break;
      }

    } else if (tiptoolpara === "pm_10_raw_mean") {
      switch (true) {
        case code >= 0 && code <= 50:
          return "good";
        case code >= 51 && code <= 100:
          return "satisfactory";
        case code >= 101 && code <= 250:
          return "moderate";
        case code >= 251 && code <= 350:
          return "poor";
        case code >= 351 && code <= 430:
          return "verypoor";
        case code >= 431 && code <= 2000: // 2000 is abitrary boundary for sanity check  
          return "severe";
        default:
          break;
      }

    } else if (tiptoolpara === "aqi") {
      switch (true) {
        case code >= 0 && code <= 50:
          return "good";
        case code >= 51 && code <= 100:
          return "satisfactory";
        case code >= 101 && code <= 200:
          return "moderate";
        case code >= 201 && code <= 300:
          return "poor";
        case code >= 301 && code <= 400:
          return "verypoor";
        case code >= 401 && code <= 2000: // 2000 is abitrary boundary for sanity check  
          return "severe";
        default:
          break;
      }
    }
  }

  function handleToolTipCss(val) {
    return "tooltip-" + handleCssForLegend(val);
  }

  if (alldata == "mapdatapoint1") {
    mapdatapoint1 = mapcoor
      .filter((e) => e.properties[content] == filterall)
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={good_icon}
        >

          <Tooltip permanent={true} direction="top" className={handleToolTipCss(park.properties[`${tiptoolpara}`].toFixed(0))} >
            <strong>
              {park.properties[`${tiptoolpara}`] != null
                ? park.properties[`${tiptoolpara}`].toFixed(0)
                : ""}
            </strong>
          </Tooltip>

          <Popup className="leaflet-popup-new">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">PM10</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_10_raw_mean"] == null
                        ? []
                        : park.properties["pm_10_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">PM2.5</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">AQI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["aqi"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </Popup>
          ;
        </Marker>
      ));
  } else if (alldata == "good") {
    mapdatapoint1 = mapcoor
      .filter(
        (e) =>
          e.properties["pm_2.5_raw_mean"] < 30 &&
          e.properties["pm_2.5_raw_mean"] > 0
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={good_icon}
        >
          <Tooltip permanent={true} direction="top" className="tooltip-good">
            <strong>
              {park.properties[`${tiptoolpara}`] != null
                ? park.properties[`${tiptoolpara}`].toFixed(0)
                : ""}
            </strong>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">PM10</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_10_raw_mean"] == null
                        ? []
                        : park.properties["pm_10_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">PM2.5</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">AQI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["aqi"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </Popup>
          ;
        </Marker>
      ));
  } else if (alldata == "Satisfactory") {
    mapdatapoint1 = mapcoor
      .filter(
        (e) =>
          e.properties["pm_2.5_raw_mean"] < 60 &&
          e.properties["pm_2.5_raw_mean"] > 31
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={satisfactory_icon}
        >
          <Tooltip permanent={true} direction="top" className="tooltip-satisfactory">
            <strong>
              {park.properties[`${tiptoolpara}`] != null
                ? park.properties[`${tiptoolpara}`].toFixed(0)
                : ""}
            </strong>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">PM10</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_10_raw_mean"] == null
                        ? []
                        : park.properties["pm_10_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">PM2.5</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">AQI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["aqi"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </Popup>
          ;
        </Marker>
      ));
  } else if (alldata == "moderate") {
    mapdatapoint1 = mapcoor
      .filter(
        (e) =>
          e.properties["pm_2.5_raw_mean"] < 90 &&
          e.properties["pm_2.5_raw_mean"] > 61
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={moderate_icon}
        >
          <Tooltip permanent={true} direction="top" className="tooltip-moderate">
            <strong>
              {park.properties[`${tiptoolpara}`] != null
                ? park.properties[`${tiptoolpara}`].toFixed(0)
                : ""}
            </strong>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">PM10</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_10_raw_mean"] == null
                        ? []
                        : park.properties["pm_10_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">PM2.5</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">AQI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["aqi"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </Popup>
          ;
        </Marker>
      ));
  } else if (alldata == "poor") {
    mapdatapoint1 = mapcoor
      .filter(
        (e) =>
          e.properties["pm_2.5_raw_mean"] < 120 &&
          e.properties["pm_2.5_raw_mean"] > 91
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={poor_icon}
        >
          <Tooltip permanent={true} direction="top" className="tooltip-poor">
            <strong>
              {park.properties[`${tiptoolpara}`] != null
                ? park.properties[`${tiptoolpara}`].toFixed(0)
                : ""}
            </strong>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">PM10</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_10_raw_mean"] == null
                        ? []
                        : park.properties["pm_10_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">PM2.5</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">AQI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["aqi"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </Popup>
          ;
        </Marker>
      ));
  } else if (alldata == "verypoor") {
    mapdatapoint1 = mapcoor
      .filter(
        (e) =>
          e.properties["pm_2.5_raw_mean"] < 250 &&
          e.properties["pm_2.5_raw_mean"] > 121
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={verypoor_icon}
        >
          <Tooltip permanent={true} direction="top" className="tooltip-verypoor">
            <strong>
              {park.properties[`${tiptoolpara}`] != null
                ? park.properties[`${tiptoolpara}`].toFixed(0)
                : ""}
            </strong>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">PM10</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_10_raw_mean"] == null
                        ? []
                        : park.properties["pm_10_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">PM2.5</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">AQI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["aqi"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </Popup>
          ;
        </Marker>
      ));
  } else {
    mapdatapoint1 = mapcoor
      .filter(
        (e) =>
          e.properties["pm_2.5_raw_mean"] < 1000 &&
          e.properties["pm_2.5_raw_mean"] > 251
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={severe_icon}
        >
          <Tooltip permanent={true} direction="top" className="tooltip-severe">
            <strong>
              {park.properties[`${tiptoolpara}`] != null
                ? park.properties[`${tiptoolpara}`].toFixed(0)
                : ""}
            </strong>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">PM10</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_10_raw_mean"] == null
                        ? []
                        : park.properties["pm_10_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">PM2.5</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">AQI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["aqi"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </Popup>
          ;
        </Marker>
      ));
  }

  // //////////////////////Legend Code ///////////////////////////

  if (tiptoolpara === "pm_2.5_raw_mean") {
    legend = <img src={pm25} alt="pm2.5" width="600" />;
  } else if (tiptoolpara === "pm_10_raw_mean") {
    legend = <img src={pm10} alt="pm10" width="600" />;
  } else if (tiptoolpara === "aqi") {
    legend = <img src={aqi} alt="aqi1" width="600" />;
  }

  if (markercd.checked == false) {
    cluster = mapdatapoint1;
  } else {
    cluster = <MarkerClusterGroup>{mapdatapoint1}</MarkerClusterGroup>;
  }

  // console.log('markercd',markercd)

  // ////////////////////////////MAIN CODE/////////////////////////

  return (
    <div className="leaflet-container-new">
      <Navbar />
      <MapContainer center={[20.5937, 78.9629]} zoom={4} maxZoom={17}>
        <TileLayer
          url='https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}'
          attribution='Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012'
        />

        <WMSTileLayer
          format="image/png"
          layers={["geonode:states_in_india"]}
          url="http://pmuy-iitkaq.urbansciences.in/geoserver/wms"
          transparent="true"
          opacity="0.2"
        />
        {/* //////////////////////////// Different Marker ///////////////////////////////////// */}
        {cluster}
        {/* ////////////////////////////////    POPUP   ///////////////////////////////////////// */}
      </MapContainer>
      <div className="mapChartOption">
        <form className="map-form">
          <div className="row map-filter">
            <div className="font-weight-bold">
              <label>
                <p style={inputLable}>Locality</p>
                <select
                  className="custom-select-input"
                  style={inputStyle}
                  value={filterall}
                  onChange={handleFilterLocality}
                >
                  <option value="select">Select</option>
                  {newLocation
                    .filter((obj) => obj != null)
                    .map((obj) => (
                      <option key={obj}>{obj}</option>
                    ))}
                </select>
              </label>
            </div>

            <div className="font-weight-bold">
              <label>
                <p style={inputLable}>Imei</p>
                <select
                  className="custom-select-input"
                  style={inputStyle}
                  value={filterall}
                  onChange={handleFilterImei}
                >
                  <option value="select">Select</option>
                  {mapcoor
                    .filter((obj) => obj.properties.imei != null)
                    .map((obj) => (
                      <option key={obj.imei}>{obj.properties.imei}</option>
                    ))}
                </select>
              </label>
            </div>

            <div className="font-weight-bold">
              <label>
                <p style={inputLable}>Parameter</p>
                <select
                  className="custom-select-input"
                  style={inputStyle}
                  value={alldata}
                  onChange={handleAlldata}
                >
                  <option value={"mapdatapoint1"}>select</option>
                  <option value={"good"}>good</option>
                  <option value={"Satisfactory"}>Satisfactory</option>
                  <option value={"moderate"}>moderate</option>
                  <option value={"poor"}>poor</option>
                  <option value={"verypoor"}>verypoor</option>
                  <option value={"severe"}>severe</option>
                </select>
              </label>
            </div>
            <div className="font-weight-bold">
              <label>
                <p style={inputLable}>Reset Filter</p>
                <button
                  type="button"
                  className="map-button"
                  onClick={handleReset}
                  style={{ width: "125px" }}
                >
                  <a
                    className="map-button-text"
                    style={{ textDecoration: "none" }}
                  >
                    Reset
                  </a>
                </button>
              </label>
            </div>
          </div>
          <div className="resetcluster">
            <div className="font-weight-bold">
              <BootstrapSwitchButton
                checked={true}
                onstyle="outline-success"
                offstyle="outline-danger"
                onlabel="Cluster"
                width={100}
                offlabel="Uncluster"
                onChange={(checked: boolean) => {
                  setMarkercd({ checked });
                }}
              />
            </div>
          </div>
          <div className="sensorbutton">
            <div className="font-weight-bold mr-2 my-2">
              <button type="button" className="map-button" onClick={handleAqi}>
                <a
                  className="map-button-text"
                  style={{ textDecoration: "none" }}
                >
                  AQI
                </a>
              </button>
            </div>

            <div className="font-weight-bold mr-2 my-2">
              <button type="button" className="map-button" onClick={handlePm25}>
                <a
                  className="map-button-text"
                  style={{ textDecoration: "none" }}
                >
                  PM2.5
                </a>
              </button>
            </div>

            <div className="font-weight-bold my-2">
              <button type="button" className="map-button" onClick={handlePm10}>
                <a
                  className="map-button-text"
                  style={{ textDecoration: "none" }}
                >
                  PM10
                </a>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div className="my-legend">{legend}</div>
      <div className="map-bottom">
        <p>
          Disclaimer : All efforts have been made to make the Map accurate. The
          boundaries shown for the states and country are from{" "}
          <a href="http://www.surveyofindia.gov.in/pages/display/235-political-map-of-india">
            Survey of India, Government of India
          </a>
          . The Map shown here should be used only for educational and research
          purposes.
        </p>
      </div>
    </div>
  );
}
export default Mapsnew;